import { computed, type ComputedRef } from 'vue'

import {
  getDashboardSections,
  type DashboardSectionItem,
} from '@/config/dashboardSections'
import { useUserStore } from '@/stores/userStore'

interface UseDashboardSectionsResult {
  sections: ComputedRef<DashboardSectionItem[]>
  isNavigationLoading: ComputedRef<boolean>
}

export const useDashboardSections = (): UseDashboardSectionsResult => {
  const userStore = useUserStore()

  const sections = computed(() => {
    return getDashboardSections(userStore.availablePermissions)
  })

  const isNavigationLoading = computed(() => {
    return userStore.isLoggedIn && !userStore.userData
  })

  return {
    sections,
    isNavigationLoading,
  }
}
